var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('formativetest',{attrs:{"query":"https://studmed.uio.no/vp/quizasjson?quiztopic=Child%20abuse%20and%20neglect&qlist=1000_30373_&locale=en"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }